import Inputmask from "inputmask";
const MaskDirective = angular
    .module("MaskDirective", [])
    .directive("pwMask", ["$timeout", maskDirective]);

function maskDirective($timeout) {
    return {
        link: function (scope, elem, attrs) {
            $timeout(function () {
                let DOM_elem = elem[0];
                Inputmask({
                    mask: attrs.pwMask,
                    autoUnmask: true,
                    showMaskOnHover: false,
                    showMaskOnFocus: false
                }).mask(DOM_elem);
            });
        }
    };
}

export default MaskDirective;
